<template>
  <div class="FreePcontent">
    <van-cell-group>
      <van-cell title="城市" is-link :value="city" @click="onCity"/>
      <van-cell title="地区" is-link :value="district" @click="onDistrict"/>
      <van-cell title="小区" is-link :value="villageData.villageName" @click="onVillage"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="楼栋" is-link :value="buildingData.buildingName" @click="onBuilding"/>
      <van-cell title="单元" is-link :value="unit?unit:'请选择您所在的单元'" @click="onUnit"/>
      <van-cell title="楼层" is-link :value="floorNo?floorNo:'请选择您所在的楼层'" @click="onFloor"/>
      <van-cell title="室号" is-link :value="roomNo?roomNo:'请选择您所在的室号'" @click="onRoom"/>
    </van-cell-group>
    <van-cell-group class="cardIcon">
      <van-field
        v-model="userCardNumber"
        required
        clearable
        label="热力卡号"
        placeholder="请输入热力卡号"
        @blur = "Cardtest"
      />
    </van-cell-group>
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="saveBth" :disabled="isSave" @click.prevent="UpdateInfo">去查询</van-button>
    </van-col>
    <van-popup
      v-model="isShow"
      position="bottom"
    >
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onCityConfirm"
        @cancel="cnacelShow"
        v-show = 'isCity'
        value-key="regionName"
      />
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onDistrictConfirm"
        @cancel="isShow = false"
        v-show = 'isDistrict'
        value-key="regionName"
      />
      <van-picker
        show-toolbar
        :columns="BUFRinfo"
        @confirm="onUFRConfirm"
        @cancel="isShow = false"
        v-show = 'isUFRpop'
        :value-key="infoKey"
      />
    </van-popup>
    <div class="popCon" v-show="isVillage" v-if="villageList">
      <div class="returnBtn"><van-button icon="arrow-left" type="primary" @click="isVillage=false">返回</van-button></div>
      <van-index-bar :index-list="indexList" sticky >
        <div v-for="index in indexList" :key="index">
          <van-index-anchor :index="index"/>
          <div v-for="item in villageList">
            <van-cell :title="item.villageName" v-if="item.villageNameS == index" @click="VillageSelect(item.villageId,item.villageName)"/>
          </div>
        </div>
      </van-index-bar>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { reqArea, reqVillage, reqRoominfoList, reqBuilding, reqBuildingDetail} from '../../api'
  import vPinyin from '../../common/js/vue-py.js';
  import commonJS from '../../common/js/commonJS.js';
  export default {
    name:"freedompayment",
    i18n: {
      'zh-CN': {
        text: '文本',
        customIndexList: '自定义索引列表'
      },
      'en-US': {
        text: 'Text',
        customIndexList: 'Custom Index List'
      }
    },
    data() {
      return {
        isSave:true,
        isShow: false,
        userCardNumber:'',
        city:'请选择您所在的城市',
        isCity:false,
        district:'请选择您所在的地区',
        isDistrict:false,
        villageData:{
          villageId:'',
          villageName:'请选择您所在的小区',
        },
        villageList:[],
        isVillage:false,
        columns:[],
        buildingData:{
          buildingName:'请选择您所在的楼栋',
          buildingId:''
        },
        unit:'',
        floorNo:'',
        roomNo:'',
        roomId:'',
        isUFRpop:false,
        BUFRinfo:[],
        infoKey:'buildingName',//分别四个 楼栋 单元 楼层 室号 的value-key不一样  动态设置
        AreaCity:{
          trendName:'',
          trendId:''
        },
        AreaDistrict:{
          trendName:'',
          trendId:''
        },
        indexList:[]
      }
    },
    methods:{
      /*
      * 获取城区
      * */
      reqAreaData(AreaData){
        if(!AreaData){
          AreaData = {}
        }
        reqArea(AreaData).then(res => {
          if(res.success){
            this.columns = res.data
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
      },
      /*
      * 点击选取城市
      * */
      onCity(){
        this.AreaDistrict.trendName =''
        this.AreaDistrict.trendId =''
        this.district = '请选择您所在的地区'
        this.villageData.villageId = '';
        this.villageData.villageName = '请选择您所在的小区';
        this.isShow = true
        this.isCity = true
        this.isDistrict = false
        this.reqAreaData();
      },
      /*
      * 点击选取区
      * */
      onDistrict(){
        if(!this.AreaCity.trendId||!this.AreaCity.trendName){
          Toast.fail({message:'请先选择城市！',className:'apiLoading'});
          return false
        }
        this.villageData.villageId = '';
        this.villageData.villageName = '请选择您所在的小区';
        this.isShow = true
        this.isCity = false
        this.isDistrict = true
      },
      /*
      * 点击城市选取弹窗确定
      * */
      onCityConfirm(value, index){
        this.AreaCity.trendName = value.regionName
        this.AreaCity.trendId = value.regionId;
        this.isShow = false
        this.isCity = false
        this.city = value.regionName
        this.reqAreaData(this.AreaCity);
      },
      /*
     * 点击区选取弹窗确定
     * */
      onDistrictConfirm(value, index){
        this.AreaDistrict.trendName = value.regionName
        this.AreaDistrict.trendId = value.regionId;
        this.isShow = false
        this.isDistrict = false
        this.district = value.regionName
      },
      /*
      *  点击获取小区列表
      * */
      onVillage(){
        let _that = this
        _that.isVillage = false
        if(this.AreaDistrict.trendId){
          let data = {
            trendId:this.AreaDistrict.trendId,
            companyId:this.$cookies.get('companyId') // TODO 微信进来取companyId
          }
          //获取对应小区
          reqVillage(data).then(res => {
            if(res.success){
              _that.villageList = res.data;
              for(let k in _that.villageList){
                let villageNameS = '',villageNameP='';
                //把小区转换成拼音取首字母排序去重
                villageNameP = vPinyin.chineseToPinYin(_that.villageList[k].villageName);
                villageNameS= villageNameP.substr(0,1);
                _that.indexList.push(villageNameS);
                _that.indexList = commonJS.unique5(_that.indexList)
                _that.indexList = commonJS.letterSort(_that.indexList)
                _that.villageList[k].villageNameS = villageNameS
              }
              if(_that.villageList.length == 0){
                Toast.fail({message:'暂无开通缴费的小区！',className:'apiLoading'});
              }else if(_that.villageList.length > 0){
                _that.isVillage = true
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
        }else{
          Toast.fail({message:'请先选择城市和地区！',className:'apiLoading'});
        }
      },
      /*
      *  点击选择小区
      * */
      VillageSelect(villageId,villageName){
        this.villageData.villageId = villageId;
        this.villageData.villageName = villageName;
        this.isVillage = false
      },
      /*
      * 下拉框点击取消
      * */
      cnacelShow(){
        this.isShow = false
        this.isCity = false
        this.isDistrict = false
        this.isUFRpop = false
      },
      /*
     * 点击获取楼栋列表
     * */
      onBuilding(){
        if(this.villageData.villageId){
          this.infoKey = 'buildingName'
          let _that = this
          //获取楼栋列表
          let data = {
            villageId:_that.villageData.villageId
          }
          reqBuilding(data).then(res => {
            if(res.success){
              _that.BUFRinfo = res.data
              if(_that.BUFRinfo.length == 0){
                Toast.fail({message:'暂无开通缴费的楼栋！',className:'apiLoading'});
              }
            }else {
              Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
            }
          })
          this.isShow = true
          this.isUFRpop = true
        }else{
          Toast.fail({message:'请先选择小区！',className:'apiLoading'});
        }
      },
      /*
      * 点击获取单元列表
      * */
      onUnit(){
        if(this.buildingData.buildingId){
          this.infoKey = 'unit'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      /*
      * 点击获取楼层列表
      * */
      onFloor(){
        if(this.buildingData.buildingId&&this.unit){
          this.infoKey = 'floorNo'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId,
            unit:this.unit
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      onRoom(){
        if(this.buildingData.buildingId&&this.floorNo){
          this.infoKey = 'roomNo'
          this.isShow = true
          this.isUFRpop = true
          let data = {
            buildingId:this.buildingData.buildingId,
            unit:this.unit,
            floorNo:this.floorNo
          }
          this.getBuildingDetail(data);
        }else{
          Toast.fail({message:'请先选择楼栋！',className:'apiLoading'});
        }
      },
      /*
      * 楼栋 单元 楼层 室号 点击确定
      * */
      onUFRConfirm(value){
        if(this.infoKey == 'buildingName'){
          this.buildingData.buildingName = value.buildingName
          this.buildingData.buildingId = value.buildingId
          this.unit = ''
          this.floorNo = ''
          this.roomNo = ''
          this.roomId = ''
        }else if(this.infoKey == 'unit'){
          this.unit = value.unit
          this.floorNo = ''
          this.roomNo = ''
          this.roomId = ''
        }else if(this.infoKey == 'floorNo'){
          this.floorNo = value.floorNo
          this.roomNo = ''
          this.roomId = ''
        }else if(this.infoKey == 'roomNo'){
          this.roomNo = value.roomNo
          this.roomId = value.roomId
        }
        this.isShow = false
        this.isUFRpop = false
        this.BUFRinfo = []
      },
      /*
     * 热力卡号input失去焦点验证必填
     * */
      Cardtest(){
        let testVerify = this.testVerify();
        if(!testVerify){
          this.isSave = true
        }else{
          this.isSave = false
        }
      },
      /*
      * 获取楼栋明细
      * */
      getBuildingDetail(data){
        let _that = this
        reqBuildingDetail(data).then(res => {
          if(res.success){
            _that.BUFRinfo = res.data
            if(_that.BUFRinfo.length == 0){
              Toast.fail({message:'暂无开通缴费！',className:'apiLoading'});
            }
          }else {
            Toast.fail({message:'系统错误，请联系管理员！',className:'apiLoading'});
          }
        })
      },
      /*
     *  必填验证
     * */
      testVerify(){
        if(!this.AreaCity.trendId||!this.AreaCity.trendName){
          Toast.fail({message:'请选择城市！',className:'apiLoading'});
          return false
        }
        if(!this.AreaDistrict.trendId||!this.AreaDistrict.trendName){
          Toast.fail({message:'请选择区！',className:'apiLoading'});
          return false
        }
        if(!this.villageData.villageName||!this.villageData.villageId){
          Toast.fail({message:'请选择所在小区！',className:'apiLoading'});
          return false
        }
        if(!this.buildingData.buildingName||!this.buildingData.buildingId){
          Toast.fail({message:'请选择所在楼栋！',className:'apiLoading'});
          return false
        }
        if(!this.unit){
          Toast.fail({message:'请选择所在单元！',className:'apiLoading'});
          return false
        }
        if(!this.floorNo){
          Toast.fail({message:'请选择所在楼层！',className:'apiLoading'});
          return false
        }
        if(!this.roomId){
          Toast.fail({message:'请选择所在室号！',className:'apiLoading'});
          return false
        }
        if(!this.userCardNumber){
          Toast.fail({message:'请填写热力卡号！',className:'apiLoading'});
          return false
        }
        return true
      },
      /*
      * 去查询
      * */
      UpdateInfo(){
        let testVerify = this.testVerify();
        if(testVerify){
          this.$router.push({
            path:'/paydetail',
            name:'paydetail',
            query:{roomId:this.roomId}
          })
        }else{
          this.isSave = true
          Toast.fail({message:'请填写热力卡号！',className:'apiLoading'});
        }
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .FreePcontent
    .van-cell-group
      margin-top 8px
      .van-cell
        height 98px!important
        line-height 98px
        font-size 30px
        color #222222
        padding-left 40px
        .van-cell__value
          font-size 28px
        .van-cell__left-icon, .van-cell__right-icon
          font-size 26px
          margin 0px 10px
          line-height 98px
        .van-field__control
          text-align right
          padding-right 40px
        .van-field__label
          width 120px
    .van-picker__toolbar
      height 85px
      .van-picker__confirm, .van-picker__cancel
        font-size 28px
        line-height 85px
    .van-picker-column
      font-size 32px
    .cardIcon
      padding-right 10px
      input
        padding-right 50px!important
        background url("../HouseholdPayment/images/saosao.png") no-repeat center right
        background-size 32px auto
    .barBtn
      padding 20% 40px 0px
      .saveBth
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        margin-top 200px
        line-height 88px
    .van-popup
      box-sizing border-box
      padding 20px
      &--right
        width 100%
        height 100%
    .popCon
      width 100%
      height 100%
      background #ffffff
      position absolute
      top 0px
      left 0px
      .returnBtn
        background #ebedf0
        margin-bottom 10px
    .van-index-bar
      padding 0px 30px
      .van-index-bar__index
        font-size 24px
        line-height 40px
      .van-index-anchor
        font-size 30px
        background #ccc
        padding 8px 10px
      .van-cell
        font-size 28px
        padding 10px 20px
        line-height 45px
        border-bottom 1px solid #ccc
</style>



// WEBPACK FOOTER //
// src/pages/FreedomPayment/FreedomPayment.vue